import { all } from 'redux-saga/effects';

import {
  createUserRequestWatchSaga,
  userUpdateRequestWatchSaga,
  usersRequestWatchSaga,
  userActivityLogsWatchSaga,
  userActivityLogsExportWatchSaga,
  userActivityLogsActionsWatchSaga,
  userActivityLogsModulesWatchSaga,
} from './users/saga';
import {
  platformUpdateRequestWatchSaga,
  platformCreateRequestWatchSaga,
  platformUploadMediaRequestWatchSaga,
} from './platforms/saga';
import {
  lanesUpdateRequestWatchSaga,
  lanesCreateRequestWatchSaga,
  lanesTypeGetRequestWatchSaga,
} from './platforms/wimLanes/saga';
import {
  groupsGetRequestWatchSaga,
  addWimGroupRequestSagaWatchSaga,
  deleteWimGroupRequestSagaWatchSaga,
} from './platforms/wimGroups/saga';
import { groupsRequestWatchSaga, createGroupRequestWatchSaga, groupUpdateRequestWatchSaga } from './groups/saga';
import { settingsRequestWatchSaga, settingsUpdateRequestWatchSaga } from './settings/saga';
import { certificatesRequestWatchSaga, certificatesUpdateWatchSaga } from './certificates/saga';
import {
  usergroupUpdateRequestWatchSaga,
  usergroupCreateGroupRequestWatchSaga,
  usergroupsRequestWatchSaga,
} from './usergroups/saga';
import {
  exportDumpFoldersWatchSaga,
  exportDumpTriggerWatchSaga,
  exportDumpDeleteWatchSaga,
  exportDumpDownloadWatchSaga,
} from './dump/saga';
import {
  validationRulesCreateWatchSaga,
  validationRulesRequestWatchSaga,
  validationRulesUpdateWatchSaga,
} from './validation-rules/saga';

export function* adminWatchSaga() {
  yield all([
    usersRequestWatchSaga(),
    userUpdateRequestWatchSaga(),
    createUserRequestWatchSaga(),
    platformUpdateRequestWatchSaga(),
    platformCreateRequestWatchSaga(),
    lanesUpdateRequestWatchSaga(),
    lanesCreateRequestWatchSaga(),
    groupsRequestWatchSaga(),
    createGroupRequestWatchSaga(),
    groupUpdateRequestWatchSaga(),
    groupsGetRequestWatchSaga(),
    addWimGroupRequestSagaWatchSaga(),
    deleteWimGroupRequestSagaWatchSaga(),
    settingsRequestWatchSaga(),
    settingsUpdateRequestWatchSaga(),
    userActivityLogsWatchSaga(),
    platformUploadMediaRequestWatchSaga(),
    userActivityLogsExportWatchSaga(),
    certificatesRequestWatchSaga(),
    certificatesUpdateWatchSaga(),
    usergroupsRequestWatchSaga(),
    usergroupUpdateRequestWatchSaga(),
    usergroupCreateGroupRequestWatchSaga(),
    exportDumpFoldersWatchSaga(),
    exportDumpTriggerWatchSaga(),
    exportDumpDeleteWatchSaga(),
    exportDumpDownloadWatchSaga(),
    lanesTypeGetRequestWatchSaga(),
    userActivityLogsActionsWatchSaga(),
    validationRulesRequestWatchSaga(),
    validationRulesCreateWatchSaga(),
    validationRulesUpdateWatchSaga(),
    userActivityLogsModulesWatchSaga(),
  ]);
}
